app.filter('truncateName', () => {
	return (text, truncateLength) => {
		return text.ellipsis(truncateLength);
	};
});
